var _path, _path2, _g, _path3, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 85,
    viewBox: "0 0 84 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_157_4553",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 84,
    height: 85
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.136719 0.890625H83.4596V84.2135H0.136719V0.890625Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_157_4553)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_157_4553",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 84,
    height: 85
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7982 0.890625C18.7878 0.890625 0.136719 19.5417 0.136719 42.5521C0.136719 65.5625 18.7878 84.2135 41.7982 84.2135C64.8034 84.2135 83.4596 65.5625 83.4596 42.5521C83.4596 19.5417 64.8034 0.890625 41.7982 0.890625Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_157_4553)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.136719 0.890625H83.4596V84.2135H0.136719V0.890625Z",
    fill: "#52539F"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_157_4553",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 22,
    width: 41,
    height: 41
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.668 22.416H61.6628V62.416H21.668V22.416Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_157_4553)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.9063 22.416C36.3594 22.416 35.6927 22.416 33.5885 22.5306C31.4792 22.5306 29.9271 22.9733 28.7083 23.416C27.375 23.9733 26.2656 24.6348 25.1563 25.7441C24.0469 26.8535 23.3802 27.9629 22.8281 29.2962C22.2708 30.6243 21.9427 32.0671 21.9427 34.1764C21.7187 36.5046 21.7188 37.1712 21.7188 42.6087C21.7188 48.1504 21.7187 48.8171 21.8281 50.9264C21.8281 53.0358 22.2708 54.5879 22.7188 55.8066C23.2708 57.14 23.9375 58.2441 25.0469 59.3535C26.1563 60.4629 27.2656 61.1296 28.5938 61.6869C29.9271 62.2389 31.3698 62.5723 33.474 62.5723C35.5833 62.5723 36.3594 62.6816 41.7969 62.6816C47.2292 62.6816 48.0052 62.6816 50.1146 62.5723C52.224 62.5723 53.776 62.1296 54.9948 61.6869C56.3281 61.1296 57.4375 60.4629 58.5469 59.3535C59.6563 58.2441 60.3177 57.14 60.875 55.8066C61.3177 54.4733 61.7604 53.0358 61.7604 50.9264C61.7604 48.8171 61.875 48.041 61.875 42.6087C61.875 37.0619 61.875 36.3952 61.7604 34.2858C61.7604 32.1816 61.3177 30.6243 60.875 29.4056C60.3177 28.0775 59.6563 26.9681 58.5469 25.8587C57.4375 24.7493 56.3281 24.0827 54.9948 23.5254C53.6667 22.9733 52.224 22.64 50.1146 22.64C48.1198 22.416 47.4531 22.416 41.9063 22.416ZM40.1302 26.0775C40.6875 26.0775 41.2396 26.0775 41.9063 26.0775C47.3437 26.0775 47.8958 26.0775 50.1146 26.1921C52.1094 26.1921 53.1094 26.6348 53.8854 26.8535C54.8854 27.1868 55.5521 27.6296 56.2135 28.4056C56.8802 29.0723 57.3229 29.7389 57.7708 30.7389C57.9896 31.4004 58.3229 32.5098 58.4323 34.5098C58.4323 36.6139 58.5469 37.2806 58.5469 42.7181C58.5469 48.1504 58.5469 48.7077 58.4323 50.9264C58.4323 52.9212 57.9896 53.9212 57.7708 54.6973C57.4375 55.6973 56.9948 56.3587 56.2135 57.0254C55.5521 57.6921 54.8854 58.1348 53.8854 58.5775C53.2188 58.9108 52.1094 59.1348 50.1146 59.2441C48.0052 59.2441 47.3437 59.3535 41.9063 59.3535C36.474 59.3535 35.9167 59.3535 33.6979 59.2441C31.7031 59.2441 30.7031 58.8014 29.9271 58.5775C28.9271 58.2441 28.2656 57.8014 27.599 57.0254C26.9323 56.3587 26.4896 55.6973 26.0469 54.6973C25.8229 54.0306 25.4896 52.9212 25.3802 50.9264C25.3802 48.8171 25.2656 48.1504 25.2656 42.7181C25.2656 37.2806 25.2656 36.7285 25.3802 34.5098C25.3802 32.5098 25.8229 31.515 26.0469 30.7389C26.375 29.7389 26.8229 29.0723 27.599 28.4056C28.2656 27.7441 28.9271 27.2962 29.9271 26.8535C30.5938 26.5202 31.7031 26.3014 33.6979 26.1921C35.5833 26.1921 36.25 26.1921 40.0208 26.0775H40.1302ZM41.9063 32.291C36.1406 32.291 31.4792 36.9473 31.4792 42.7181C31.4792 48.4837 36.1406 53.1452 41.9063 53.1452C47.6771 53.1452 52.3333 48.4837 52.3333 42.7181C52.3333 36.9473 47.6771 32.291 41.9063 32.291ZM41.9063 35.9525C45.6771 35.9525 48.6719 38.9473 48.6719 42.7181C48.6719 46.4889 45.6771 49.4837 41.9063 49.4837C38.1354 49.4837 35.1406 46.4889 35.1406 42.7181C35.1406 38.9473 38.1354 35.9525 41.9063 35.9525Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnInstagram);
export default __webpack_public_path__ + "static/media/icn_instagram.58b56127cc40ca798f219afe0fd65f71.svg";
export { ForwardRef as ReactComponent };